import { FEATURE_CAPTURE_ADDRESS_SELL_SCREEN } from '../../../../../constants'
import { FulfilmentType } from '../../../../../models/fulfilment'
import { useAppSelector } from '../../../../../state/hooks'
import {
  selectIsEcomOrder,
  selectIsParkedSale,
  selectSaleFulfilmentDetail,
} from '../../../../../state/slices/currentSale/currentSaleSlice'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { useSaleHasServiceOrder } from '../../../useSaleHasServiceOrder'
import { useLineItemFulfillmentAddressDetails } from '../popover/hooks'

export const useLineItemHasFulfillmentAddressError = (): boolean => {
  const fulfillmentDetail = useAppSelector(selectSaleFulfilmentDetail)
  const { error: addressError } = useLineItemFulfillmentAddressDetails(
    fulfillmentDetail
  )

  const saleHasServiceOrder = useSaleHasServiceOrder()
  const isEcomOrder = useAppSelector(selectIsEcomOrder)
  const isParkedSale = useAppSelector(selectIsParkedSale)

  if (!getFeatureFromCache(FEATURE_CAPTURE_ADDRESS_SELL_SCREEN)) return false

  return (
    Boolean(addressError) &&
    fulfillmentDetail?.type === FulfilmentType.DELIVERY &&
    // The service order sales deal with the fulfillment in jaws so we don't need to show the error
    !saleHasServiceOrder &&
    // Ecom orders handle the address validation differently
    !isEcomOrder &&
    !isParkedSale
  )
}
